import React, { Component } from 'react'
import { Redirect } from 'react-router-dom';
import * as ROUTES from "../constants/routes";
import { useHistory } from "react-router-dom";
import translations from './Translations/index'


export default class Menu extends Component {

  constructor(props) {
    super(props);
    this.state = { user: this.props.user}
    this.logout = this.logout.bind(this)
  }

  logout(){
    // let history = useHistory()
    this.props.removeUser()
    // history.push("/login")
    //

    // return <Redirect to="/jh" />
  }


  render() {
    const { firstName, lastName, profilePicURL} = this.state.user
        return (

          <div>
            <aside className="main-sidebar">
    {/* sidebar: style can be found in sidebar.less */}
    <section className="sidebar">
      {/* Sidebar user panel */}
      <div className="user-panel">
        <div className="pull-left image">
          <img src={profilePicURL?profilePicURL:"dist/img/user2-160x160.jpg"} className="img-circle" alt="User Image" />
        </div>
        <div className="pull-left info">
          <p>{firstName + " " + lastName}</p>
          <a href="#"><i className="fa fa-circle text-success" /> Online</a>
        </div>
      </div>
      {/* search form */}
      <form action="#" method="get" className="sidebar-form">
        <div className="input-group">
          <input type="text" name="q" className="form-control" placeholder="Search..." />
          <span className="input-group-btn">
            <button type="submit" name="search" id="search-btn" className="btn btn-flat">
              <i className="fa fa-search" />
            </button>
          </span>
        </div>
      </form>
      {/* /.search form */}
      {/* sidebar menu: : style can be found in sidebar.less */}
      <ul className="sidebar-menu" data-widget="tree">
        <li className="header">MAIN NAVIGATION</li>
        <li className="active treeview">
          <a href="#">
            <i className="fa fa-dashboard" /> <span></span>
          </a>

        </li>
        {
          !this.props.user.access ==="Admin" ?
              <li><a href="/jh"><form onSubmit={this.logout}><i className="fa fa-circle-o text-aqua" /> <span>{translations.job_history[this.props.user.language]}</span></form></a></li>:
              <li className="treeview">
                <a href="#">
                  <i className="fa fa-laptop" /> <span>Admin Centre</span>
                  <span className="pull-right-container">
              <i className="fa fa-angle-left pull-right" />
            </span>
                </a>
                <ul className="treeview-menu">
                  <li><a href="/workerActions"><i className="fa fa-circle-o" /> Enable/Disable Worker</a></li>
                  <li><a href="/allJobs"><i className="fa fa-circle-o" /> Leave Applications</a></li>
                </ul>
              </li>
        }


        <li><a onClick={this.logout} href="#"><form onSubmit={this.logout}><i className="fa fa-circle-o text-aqua" /> <span>{translations.logout[this.props.user.language]}</span></form></a></li>

      </ul>
    </section>
    {/* /.sidebar */}
  </aside>
          </div>
        )
    }
}
